<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
  import * as echarts from 'echarts'
  require('echarts/theme/macarons') // echarts theme
  import resize from './mixins/resize'

  export default {
    mixins: [resize],
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      width: {
        type: String,
        default: '100%'
      },
      height: {
        type: String,
        default: '220px'
      },
      chartDate: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        chart: null
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.initChart()
      })
    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      this.chart.dispose()
      this.chart = null
    },
    watch: {
      chartDate: {
        handler(val) {
          this.setOptions(val)
        }
      },
    },
    methods: {
      initChart() {
        this.chart = echarts.init(this.$el, 'macarons')
        this.setOptions(this.chartDate)
      },
      setOptions({ data, xAxis } = {}) {
        this.chart.setOption({
          // legend: {
          //   orient: 'vertical', // 图例列表的布局朝向，垂直排列
          //   align: 'left', // 图例的对齐方式
          //   data: ['男', '女'], // 图例数据，对应 series 的 name
          //   left: 'right', // 图例组件离容器右侧的距离
          //   top: 'center', // 图例组件离容器顶部的距离
          //   icon: 'circle', // 图例的图标类型，设置为圆形
          //   textStyle: {
          //     color: '#FFFFFF', // 图例文字颜色，设置为白色
          //     fontSize: 14 // 图例文字大小
          //   }
          // },
          tooltip: {
            // trigger: 'item',
            // formatter: '{a} <br/>{b} : {c} ({d}%)'
          },


          grid: {
            top: '3%',
            left: '0',
            right: '0',
            bottom: '3%',
            containLabel: true
          },
          series: [
            // {
            //   // name: 'WEEKLY WRITE ARTICLES',
            //   type: 'pie',
            //   roseType: 'radius',
            //   radius: [0, 90],
            //   // radius: '50%',
            //   center: ['50%', '50%'],
            //   // data: [
            //   //   { value: 320, name: '驻场人员', itemStyle: { color: '#868686' } },
            //   //   { value: 240, name: '公司人员', itemStyle: { color: '#D9D9D9' } },

            //   // ],
            //   data: this.chartDate,
            //   // animationEasing: 'cubicInOut',
            //   // animationDuration: 2600,
            //   emphasis: {
            //     itemStyle: {
            //       shadowBlur: 5,
            //       shadowOffsetX: 0,
            //       shadowColor: 'rgba(0, 0, 0, 0.5)',
            //       borderWidth: 2
            //     }
            //   }
            // },
            {
              type: 'pie',
              // radius: '50%',
              radius: [0, 90],
              // center: ['40%', '50%'], // 调整饼图的中心位置，避免与图例重叠
              data: this.chartDate,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              label: {
                show: false // 隐藏数据标签
              }
            }

          ]
        })
      },
    }
  }
</script>